// Loader.js
import React from 'react';

const Loader = ({ message }) => {
  return (
    <div style={styles.loaderContainer}>
      <div style={styles.loader}></div>
      <p style={styles.message}>{message}</p>
    </div>
  );
};

const styles = {
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh', // Full viewport height
    flexDirection: 'column',
  },
  loader: {
    border: '5px solid #f3f3f3', // Light grey
    borderTop: '5px solid #D6A300', // Amber/Gold color
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    animation: 'spin 1s linear infinite',
  },
  message: {
    marginTop: '20px',
    fontSize: '1.2rem',
    color: '#333',
    fontFamily: 'Cairo Bold, sans-serif', // Use Cairo Bold for the message
  },
};

// CSS for the spinning animation
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`, styleSheet.cssRules.length);

export default Loader;